


const SelectCatagory = ({select}) => {
    return (
        <select defaultValue={select}>
            <option value="all">Toutes les catégories</option>
            <option value="uncategorized">Uncategorized</option>
            <option value="academy">Academy</option>
            <option value="agency">Agency</option>
            <option value="app">App</option>
            <option value="bar">Bar</option>
            <option value="blog">Blog</option>
            <option value="business">Business</option>
            <option value="butcher-shop">Butcher Shop</option>
            <option value="cafe">Cafe</option>
            <option value="charity-2">Charity</option>
            <option value="church">Church</option>
            <option value="clinic">clinic</option>
            <option value="college">College</option>
            <option value="conference">Conference</option>
            <option value="construction">Construction</option>
            <option value="corona-virus">Corona Virus</option>
            <option value="corporate">Corporate</option>
            <option value="covid19">Covid19</option>
            <option value="digital-products">Digital Products</option>
            <option value="doctors">doctors</option>
            <option value="ecological">Ecological</option>
            <option value="education">Education</option>
            <option value="entertainment">Entertainment</option>
            <option value="environment">Environment</option>
            <option value="environmental">Environmental</option>
            <option value="events">Events</option>
            <option value="fitness">Fitness</option>
            <option value="food-shop">Food Shop</option>
            <option value="free">Free</option>
            <option value="gym">Gym</option>
            <option value="halloween">Halloween</option>
            <option value="health">health</option>
            <option value="healthcare">healthcare</option>
            <option value="learnpress">learnpress</option>
            <option value="meat-shop">Meat Shop</option>
            <option value="medical">medical</option>
            <option value="medical-prevention">Medical Prevention</option>
            <option value="meetup">Meetup</option>
            <option value="mobile-apps">Mobile Apps</option>
            <option value="music">Music</option>
            <option value="news">News</option>
            <option value="nonprofit">Nonprofit</option>
            <option value="onepage">Onepage</option>
            <option value="online-course">Online Course</option>
            <option value="personal-blog">Personal Blog</option>
            <option value="portfolio">Portfolio</option>
            <option value="pregnancy">pregnancy</option>
            <option value="premium">premium</option>
            <option value="psd">psd</option>
            <option value="religion">Religion</option>
            <option value="restaurants">Restaurants</option>
            <option value="school">School</option>
            <option value="seo">SEO</option>
            <option value="software">Software</option>
            <option value="startups">Startups</option>
            <option value="university">University</option>
            <option value="vcard">Vcard</option>
            <option value="woocommerce">WooCommerce</option>
            <option value="yoga">Yoga</option>
            <option value="magazine">Magazine</option>
            <option value="event-wordpress">Event</option>                        
        </select>
    );
}
 
export default SelectCatagory;